/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { GetAllAutoSaveStatusesAutoSaveType } from './get-all-auto-save-statuses-auto-save-type';

/**
 * 
 * @export
 * @interface GetAllAutoSaveStatusesDataElementDto
 */
export interface GetAllAutoSaveStatusesDataElementDto {
    /**
     * sns 계정 uuid
     * @type {string}
     * @memberof GetAllAutoSaveStatusesDataElementDto
     */
    'snsAccountUuid': string;
    /**
     * sns 고유키
     * @type {string}
     * @memberof GetAllAutoSaveStatusesDataElementDto
     */
    'snsUniqueKey': string;
    /**
     * 계정 ID
     * @type {string}
     * @memberof GetAllAutoSaveStatusesDataElementDto
     */
    'snsId': string;
    /**
     * sns 계정 종류
     * @type {string}
     * @memberof GetAllAutoSaveStatusesDataElementDto
     */
    'snsAccountType': GetAllAutoSaveStatusesDataElementDtoSnsAccountTypeEnum;
    /**
     * 활동기능 여부
     * @type {boolean}
     * @memberof GetAllAutoSaveStatusesDataElementDto
     */
    'isActivity'?: boolean;
    /**
     * 성별
     * @type {string}
     * @memberof GetAllAutoSaveStatusesDataElementDto
     */
    'gender': GetAllAutoSaveStatusesDataElementDtoGenderEnum;
    /**
     * 나이
     * @type {number}
     * @memberof GetAllAutoSaveStatusesDataElementDto
     */
    'age': number;
    /**
     * 
     * @type {Array<GetAllAutoSaveStatusesAutoSaveType>}
     * @memberof GetAllAutoSaveStatusesDataElementDto
     */
    'snsAccountAutoSaveTypes': Array<GetAllAutoSaveStatusesAutoSaveType>;
}

export const GetAllAutoSaveStatusesDataElementDtoSnsAccountTypeEnum = {
    Viewup: 'viewup',
    ViewupPlus: 'viewupPlus'
} as const;

export type GetAllAutoSaveStatusesDataElementDtoSnsAccountTypeEnum = typeof GetAllAutoSaveStatusesDataElementDtoSnsAccountTypeEnum[keyof typeof GetAllAutoSaveStatusesDataElementDtoSnsAccountTypeEnum];
export const GetAllAutoSaveStatusesDataElementDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type GetAllAutoSaveStatusesDataElementDtoGenderEnum = typeof GetAllAutoSaveStatusesDataElementDtoGenderEnum[keyof typeof GetAllAutoSaveStatusesDataElementDtoGenderEnum];


